import { Component, Input} from '@angular/core';
import { NotificationService } from 'app/_services/notification.service';
import { ReportsService } from 'app/_services/reports.service';
import { utils as xlsx_utils, writeFile as xlsx_writeFile } from 'xlsx';

@Component({
  selector: 'app-contractor-competency-report',
  templateUrl: './contractor-competency-report.component.html',
})
export class ContractorCompetencyReport {
  @Input() siteOwnerId: any;

  constructor(
    private reportsService: ReportsService,
    private notificationService: NotificationService,
  ) {
  }

  public generateReport() {
    this.reportsService.getContractorCompetencyReport(this.siteOwnerId).subscribe((data: any) => {
      this.processDataIntoDocument(data);
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not fetch report data');
    });
  }

  private processDataIntoDocument(data) {
    const { contractors, allRelevantCompetencies } = data;

    // Define headers for the spreadsheet (including new fields)
    const headers = [
      'Contractor',
      'Manager',
      'Manager Email',
      'Manager Phone Number',
      ...allRelevantCompetencies.map(c => c.name) // Append competency names
    ];

    // Sort the data
    contractors.sort((a, b) => a.contractor.localeCompare(b.contractor));

    // Create an array of objects containing the data for each contractor
    const contractorData = contractors.map(contractor => {
      const rowData = {
        'Contractor': contractor.contractor,
        'Manager': contractor.manager,
        'Manager Email': contractor.managerEmail,
        'Manager Phone Number': contractor.managerPhoneNumber
      };

      // Add competency expiry dates
      allRelevantCompetencies.forEach(headingComp => {
        const dataComp = contractor.competencies.find(comp => comp.name === headingComp.name);
        rowData[headingComp.name] = dataComp ? new Date(dataComp.expiryDate) : null;
      });

      return rowData;
    });

    // Create a new workbook and worksheet
    const workbook = xlsx_utils.book_new();
    const worksheet = xlsx_utils.json_to_sheet(contractorData, { header: headers, cellDates: true });

    // Format the columns
    const wscols = headers.map((header, index) => {
      if (index == 0) {
        return { width: 38 }; // Set width of first column (Contractor)
      } else if (index == 1) {
        return { width: 22 }; // Manager name width
      } else if (index == 2) {
        return { width: 35 }; // Manager Email width
      } else if (index == 3) {
        return { width: 17 }; // Manager Phone width
      } else {
        return { width: 30, z: "yyyy-mm-dd" }; // Format dates for competency columns
      }
    });

    worksheet["!cols"] = wscols;
    worksheet['!autofilter'] = { ref: worksheet['!ref'] };

    xlsx_utils.book_append_sheet(workbook, worksheet, 'Contractors');
    const today = new Date();
    xlsx_writeFile(workbook, `Contractor Report ${today.toLocaleDateString()}.xlsx`);
}
  private processDataIntoDocumentold(data) {
    const { contractors, allRelevantCompetencies } = data;

    // Define headers for the spreadsheet
    const headers = allRelevantCompetencies.map(c => c.name);
    headers.unshift('Contractor');

    // Sort the data
    contractors.sort((a, b) => a.contractor.localeCompare(b.contractor));

    // Create an array of objects containing the data for each contractor
    const contractorData = contractors.map(contractor => {
      const rowData = {};

      allRelevantCompetencies.forEach(headingComp => {
        const dataComp = contractor.competencies.find(comp => comp.name === headingComp.name);
        rowData[headingComp.name] = dataComp ? new Date(dataComp.expiryDate) : null;
      });

      rowData['Contractor'] = contractor.contractor;
      return rowData;
    });

    // Create a new workbook and worksheet
    const workbook = xlsx_utils.book_new();
    const worksheet = xlsx_utils.json_to_sheet(contractorData, { header: headers, cellDates: true });

    // Format the columns
    var wscols = headers.map((header, index) => {
      if (index < 1) {
        return { width: 50 }; // set width of first column
      } else {
        return { width: 30, z: "yyyy-mm-dd" }; // date format the rest
      }
    });
    worksheet["!cols"] = wscols;
    worksheet['!autofilter'] = { ref: worksheet['!ref'] };

    xlsx_utils.book_append_sheet(workbook, worksheet, 'Contractors');
    const today = new Date();
    xlsx_writeFile(workbook, `Contractor Report ${today.toLocaleDateString()}.xlsx`);
  }
}
